<template>
    <div ref="info"></div>
</template>

<script>
import Info from "!!raw-loader!../../assets/ricoh_assets/icons/ICN003-02_info.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.info.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = Info

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>

</style>